import React from "react"
import { useTranslation } from "react-i18next"

import { scale } from "utils"

const PloptfcBranchDetails = (props) => {
  const { templateType, printData, printerWidth } = props

  const {
    branchName,
    branchAddress,
    branchContactNumber
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  return (
    <div style={styles["container"]}>
      <div style={styles["title"]}>
        {t("جزئیات فرستنده")}:
      </div>

      <div style={styles["table"]}>
        <div style={styles["row"]}>
          <div style={styles["textLeft"]}>
            {t("نام شعبه")}
          </div>
          <div style={styles["textRight"]}>
            {branchName}
          </div>
        </div>

        <div style={styles["row"]}>
          <div style={styles["textLeft"]}>
            {t("تلفن")}
          </div>
          <div style={styles["phone"]}>
            {branchContactNumber}
          </div>
        </div>

        <div style={{ ...styles["row"], borderBottom: 0 }}>
          <div style={styles["textLeft"]}>
            {t("آدرس")}
          </div>
          <div style={styles["textRight"]}>
            {branchAddress}
          </div>
        </div>
      </div>
    </div>
  )
}

const stylesThermal = (printerWidth, dir = "rtl") => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  table: {
    border: `${scale("2px")} solid`
  },

  title: {
    marginBottom: scale("4px")
  },

  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: `${scale("2px")} solid`
  },

  textLeft: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`
  },

  textRight: {
    flex: 1,
    textAlign: "center",
  },

  phone: {
    flex: 1,
    direction: "ltr",
    textAlign: "center"
  }
})

const stylesOthers = (dir = "rtl") => ({
  container: {
    marginRight: "8px",
    fontSize: "11px",
    paddingTop: "4px"
  },

  table: {
    border: "1px solid"
  },

  title: {
    marginBottom: "5px"
  },

  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: "1px solid"
  },

  textLeft: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid",
  },

  textRight: {
    flex: 1,
    textAlign: "center"
  },

  phone: {
    flex: 1,
    direction: "ltr",
    textAlign: "center"
  }
})

export default PloptfcBranchDetails